import { styled } from "@material-ui/system";
import { Typography, Box, IconButton } from "@material-ui/core";
import { bgBlur } from "utils/cssStyles";
import { LeftIcon, RightIcon } from "./CarouselIcon";
import type { IconifyProps } from "./Iconify";
import type { BoxProps } from "@material-ui/core";

const StyledRoot = styled(Box)(({ theme }) => ({
  ...bgBlur({
    opacity: 0.48,
    color: theme.palette.grey[900]
  }),
  zIndex: 9,
  display: "inline-flex",
  alignItems: "center",
  position: "absolute",
  bottom: theme.spacing(2),
  right: theme.spacing(2),
  padding: theme.spacing(0.25),
  color: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius
}));

const StyledIconButton = styled(IconButton)({
  width: 28,
  height: 28,
  padding: 0,
  opacity: 0.48,
  "&:hover": { opacity: 1 }
});

type CarouselArrowIndexProps = BoxProps & {
  icon?: IconifyProps;
  index: number;
  total: number;
  onNext?: VoidFunction;
  onPrevious?: VoidFunction;
};

export function CarouselArrowIndex({
  icon,
  index,
  total,
  onNext,
  onPrevious,
  ...other
}: CarouselArrowIndexProps): JSX.Element {
  return (
    <StyledRoot style={{ direction: "ltr" }} {...other}>
      <StyledIconButton color="inherit" onClick={onPrevious}>
        <LeftIcon icon={icon} />
      </StyledIconButton>
      <Typography variant="subtitle2" component="span" sx={{ mx: 0.25 }}>
        {index + 1}/{total}
      </Typography>
      <StyledIconButton color="inherit" onClick={onNext}>
        <RightIcon icon={icon} />
      </StyledIconButton>
    </StyledRoot>
  );
}
